// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"errorHandler_errorContainer__So6ho"};